import PropTypes from "prop-types"
import React from "react"

import { Link } from "react-router-dom"

// Import menuDropdown
import LanguageDropdown from "./LanguageDropdown"
import ProfileMenu from "./ProfileMenu"

import logoIcon from "../../assets/images/logo-icon.png"
import redirectUser from "helpers/redirectUser"
import useAuth from "hooks/useAuth"
import { Badge } from "reactstrap"
import { t } from "i18next"

// Redux Store

const Header = () => {
  const { userData } = useAuth()

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link
                to={redirectUser(userData.user_type)}
                className="logo logo-light"
              >
                <span className="logo-sm">
                  <img src={logoIcon} alt="" height="35" />
                </span>
              </Link>
            </div>
            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            <div className="d-flex gap-1">
              <p className="mb-0">{t("credit balance")}:</p>
              <Badge
                color={userData.credit === 0 ? "danger" : "success"}
                className="p-1"
              >
                {userData.credit}
              </Badge>
            </div>
          </div>
          <div className="d-flex">
            <LanguageDropdown />
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

export default Header
